import { render, staticRenderFns } from "./DraftsBriefs2.vue?vue&type=template&id=b8cc58f0"
import script from "./DraftsBriefs2.vue?vue&type=script&lang=js"
export * from "./DraftsBriefs2.vue?vue&type=script&lang=js"
import style0 from "./DraftsBriefs2.vue?vue&type=style&index=0&id=b8cc58f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports